import styled from 'styled-components';
import { colors } from 'common/theme/light.theme';

export const SipTableContainer = styled.div`
  &.sip-table-widget {
    padding-left: 1.3em;

    .changeover-program-steps {
      max-height: 30em;
    }

    th {
      padding: 0.75rem;
    }

    .parent-cell {
      display: flex;
      align-items: center;
      gap: 0.25rem;
    }

    button {
      background: none;
      border: none;
      display: flex;
      align-items: center;
      padding: 0;
      height: 1rem;
    }

    .open {
      background: ${colors.neg};
      box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
    }

    .open + * {
      td {
        padding: 0;

        div {
          margin: 0;
        }

        tfoot {
          display: none;
        }
      }

      .footer-total-count {
        margin: 0;
      }
    }

    .toolbar-wrapper {
      display: none;
    }

    .sip-table-icon-box {
      display: flex;
      gap: 0.25rem;
      align-items: center;

      svg {
        height: 1rem;
        width: 1rem;
        cursor: pointer;
      }
    }

    .sip-table-icon-error {
      svg {
        height: 1.5rem;
        padding-bottom: 0.3125rem;
      }
    }

    .sip-nested-table {
      
       table{
         th {
        padding: 0;
        border-bottom: 1px solid ${colors.gray300};
        background: linear-gradient(180deg,  #d9d9d9 0%,   #F2F3F4 95%);

       }
      thead {
         .sterilizationRunlogId {
          padding-left: 2.0625rem;
        }
      }

      .sterilizationRunlogId {
        padding-left: 2.0625rem;
      }

     
        td {
          padding: 0;
        }

        tr {
          background-color: ${colors.lightGrey1};
        }
      }

      .progressLogs {
        svg {
          height: 1rem;
          width: 1rem;
          cursor: pointer;
        }
      }
    }
  }
`;
